import http from './http'

// 获取列表
export function pageList (data) {
  return http.get('/client/user/market/pagelist?'+data)
}

// 删除同步项
export function remove (key) {
  return http.delete(`/client/user/market/share?id=${key}`)
}

export function marketCtlPost (key) {
  return http.post(`/client/user/market/status?key=${key}`)
}

export function sellConfig (key, data) {
  return http.post(`/client/user/market/config?key=${key}`, data)
}

export function marketFile (data) {
  return http.post('/client/user/market/upload', data, {headers: {'Content-Type': 'multipart/form-data'}})
}